module.exports = __webpack_public_path__ + "img/the-grace-year.27ca417e.png";